module.exports = __webpack_public_path__ + "img/avatar_41.50640d1b.svg";